export default __webpack_public_path__ + "static/cafe_36051-99ba8d6e7d9d23a87a0062cc96fde581.png";